module.exports = __webpack_public_path__ + "static/red_label_rounded-77fdfce04abbb072296ed8305545844e.png";